interface FormatApyOptions {
  locale?: string
  useParens?: boolean
  withPct?: boolean
}

export function formatApy(apy: number, options: FormatApyOptions = {}) {
  const { locale = "en", useParens = false, withPct = false } = options
  let result = apy.toFixed(2)

  if (Math.abs(apy) < 0.01 && apy !== 0) {
    result = "<0.00"
  } else if (Math.abs(apy) > 1000) {
    result = apy.toFixed(0)
    if (Math.abs(apy) > 9999) {
      result = Intl.NumberFormat(locale, { notation: "compact" }).format(apy)
    }
  }

  if (withPct) {
    result = `${result}%`
  }

  if (useParens && apy < 0) {
    result = `(${result})`
  }

  return result
}
